import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
import { offer } from '../data/content';
export function CountdownPanel() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: 'hs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'seg'
  }];
  return <div className="mx-auto w-full max-w-4xl text-center" data-id="element-51" data-mp="101li1bze9i4h">
      <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-widest text-blue-700 md:text-base" data-id="element-52" data-mp="l543ycztlpe8">
        <ClockIcon className="h-5 w-5" aria-hidden="true" data-id="element-53" data-mp="q3ns8k1vzd9r" />
        {offer.eyebrow}
      </p>

      <div className="mt-6 flex items-start justify-center gap-4 md:gap-8" role="timer" data-id="element-54" data-mp="c826qmuv3bm3">
        {units.map(unit => <div key={unit.label} className="flex flex-col items-center" data-id="element-55" data-mp="26k0f6mlck3gx">
            <span className="text-5xl font-extrabold tabular-nums leading-none tracking-tight text-blue-600 md:text-7xl" data-id="element-56" data-mp="26ks3dccm6yx6">
              {unit.value}
            </span>
            <span className="mt-2 text-xs font-bold uppercase tracking-widest text-gray-500" data-id="element-57" data-mp="1lg5d15uw0myz">
              {unit.label}
            </span>
          </div>)}
      </div>
    </div>;
}